export function interpolate(value, minInput, maxInput, minOutput, maxOutput) {
  const fraction = (value - minInput) / (maxInput - minInput)
  return minOutput + fraction * (maxOutput - minOutput)
}
